import { createApp } from 'vue';
import GifToAvifConverter from '../Components/GifToAvifConverter.vue';

const root = document.getElementById('gif-to-avif-converter');
if (root) {
  createApp(GifToAvifConverter).mount('#gif-to-avif-converter');
}
